import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import { ASSETS } from "@/lib/motion";
import { SOCIALS, CONTACT } from "@/lib/schema";

const FOOTER_LINKS = [
  { label: "Our Approach", to: "/our-approach" },
  { label: "About BWG", to: "/about-us" },
  { label: "Ayodhya", to: "/ayodhya" },
  { label: "Featured On", to: "/press" },
  { label: "Careers", to: "/careers" },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-brand-dark pt-24 pb-10 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-3 gap-12 mb-20">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-6">
              <img src={ASSETS.logoWhite} alt="Bhaarat Wealth Group logo" className="w-9 h-9 object-contain" />
              <span className="font-display font-extrabold text-2xl text-brand-offwhite">BWG<span className="text-brand-orange">.</span></span>
            </Link>
            <h2 className="font-display font-semibold text-2xl tracking-tighter text-brand-offwhite max-w-xs leading-tight">
              Land, verified. Wealth, made deliberately.
            </h2>
            <div className="flex gap-4 mt-8">
              {[[Instagram, SOCIALS.instagram], [Facebook, SOCIALS.facebook], [Linkedin, SOCIALS.linkedin]].map(([Icon, href], i) => (
                <a key={i} href={href} target="_blank" rel="noopener noreferrer" data-testid={`social-${i}`}
                  className="w-11 h-11 rounded-full border border-brand-offwhite/20 flex items-center justify-center text-brand-offwhite/70 hover:bg-brand-orange hover:border-brand-orange hover:text-white transition-colors">
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-brand-offwhite/40 mb-6">Explore</p>
            <ul className="space-y-3">
              {FOOTER_LINKS.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-brand-offwhite/70 hover:text-brand-orange transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-brand-offwhite/40 mb-6">Contact</p>
            <div className="space-y-3">
              <a href={`tel:${CONTACT.phone}`} className="flex items-center gap-3 text-brand-offwhite/70 hover:text-brand-orange transition-colors">
                <Phone className="w-4 h-4" /> {CONTACT.phone}
              </a>
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-brand-offwhite/70 hover:text-brand-orange transition-colors">
                <Mail className="w-4 h-4" /> {CONTACT.email}
              </a>
              <p className="flex items-center gap-3 text-brand-offwhite/70">
                <MapPin className="w-4 h-4" /> Connaught Place, New Delhi
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-brand-offwhite/10 pt-10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-brand-offwhite/40 max-w-2xl text-center md:text-left">
            BWG provides land sourcing, diligence, acquisition and exit advisory. A subsidiary of Philom Tech Pvt. Ltd., New Delhi.
            Not a mutual fund or pooled scheme. Past performance is historical and not indicative of future results.
          </p>
          <p className="text-xs text-brand-offwhite/40">© {new Date().getFullYear()} Bhaarat Wealth Group</p>
        </div>
      </div>
      <div className="mt-12 select-none pointer-events-none">
        <p className="font-display font-extrabold text-[18vw] leading-none tracking-tighter text-brand-offwhite/5 text-center whitespace-nowrap">
          BHAARAT WEALTH
        </p>
      </div>
    </footer>
  );
}
